// Píldora de promoción vigente para celdas y encabezados: ancho por contenido, «…» si no cabe, y el
// nombre y beneficio de cada promo en el tooltip.
import { StatusPill } from '@/shared/patterns/Pills';
import { cn } from '@/lib/cn';
import {
    PROMOTION_KIND_LABEL,
    promotionPillLabel,
    promotionPillTitle,
    sharedPromotionKind,
    type PromotionSummary,
} from './promotionView';

export const UNDETAILED_PROMOTION_LABEL = 'Promo';

export interface PromotionPillProps {
    promotions: readonly PromotionSummary[];
    /** La fuente marca promo pero no trae su detalle; se dice en el tooltip. */
    undetailedReason?: string;
    /** Antepone «Venta»/«Crédito» cuando todas las promos son del mismo tipo. */
    showKind?: boolean;
    /** Para columnas angostas: sin nombre; dice el tipo, «Promo» o «N promos» y el resto va al tooltip. */
    compact?: boolean;
    className?: string;
}

/** `null` cuando no hay promo que mostrar: la celda decide su guion. */
export function PromotionPill({
    promotions,
    undetailedReason,
    showKind = false,
    compact = false,
    className,
}: PromotionPillProps) {
    const hasDetail = promotions.length > 0;
    if (!hasDetail && undetailedReason === undefined) return null;
    const title = hasDetail ? promotionPillTitle(promotions) : undetailedReason;
    const kind = showKind ? sharedPromotionKind(promotions) : undefined;
    if (compact) {
        const short =
            promotions.length > 1
                ? promotionPillLabel(promotions)
                : kind === undefined
                  ? UNDETAILED_PROMOTION_LABEL
                  : PROMOTION_KIND_LABEL[kind];
        return (
            <StatusPill tone="info" title={title} className={cn('max-w-full', className)}>
                <span className="min-w-0 truncate">{short}</span>
            </StatusPill>
        );
    }
    const label = hasDetail ? promotionPillLabel(promotions) : UNDETAILED_PROMOTION_LABEL;
    return (
        <StatusPill tone="info" title={title} className={cn('max-w-full', className)}>
            <span className="min-w-0 truncate">
                {kind === undefined ? null : (
                    <span className="font-bold">{`${PROMOTION_KIND_LABEL[kind]} · `}</span>
                )}
                {label}
            </span>
        </StatusPill>
    );
}
